export const CoordinateType = {
  WG84: 0,
  ED50: 1,
};
